import { Component, OnInit, Input } from '@angular/core';
import { ProductsService } from '../../../services/products/products.service';
import { Product } from '../../../models/product.model';
import { CookieCiencuadras } from '../../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { HttpErrorResponse } from '@angular/common/http';
import { DetailModal } from '../../../models/detailModal.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { ProductCar } from '../../../models/productCar.model';
import { Plan } from '../../../models/plan.model';
import { addToCarPlan, removePlanFromCar } from '../../../redux/actions/carPlanCheckout.actions';
import { addToCar, modifyProduct, removeToCar } from '../../../redux/actions/carCheckout.actions';
import { ActivePlan } from '../../../models/activePlans.model';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ShoppingDialogComponent } from '../../../commons/shopping-dialog/shopping-dialog.component';
import { UserInformation } from '../../../models/userInformation.model';
import { Encrypt } from '../../../utils/encrypt/encrypt';
import { Router } from '@angular/router';
import { DataLayerService } from '../../../services/dataLayer/data-layer.service';

@Component({
  selector: 'app-my-products',
  templateUrl: './my-products.component.html',
  styleUrls: ['./my-products.component.scss']
})
export class MyProductsComponent implements OnInit {
  
  @Input() userType: number;
  products: Product[] = [];
  summary: number = 0;
  count: number = 0;
  aditionalProducts: ProductCar[] = [];
  baseAditionalProducts: ProductCar[] = [];
  activePlan!: ActivePlan;
  id: string = '';
  foto36: number = 0;
  destacados: number = 0;
  ascendidos: number = 0;
  recorrido3d: number = 0;
  precioenlinea: number = 0;
  userInformation: UserInformation;

  // countPlan: number = 0;
  constructor(
    private productsService: ProductsService,
    private cookieCiencuadras: CookieCiencuadras,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private router: Router,
    private dataLayerService: DataLayerService

  ) { }

  async ngOnInit(): Promise<void> {

    this.id = this.cookieCiencuadras.getCookie('currentUser');

    //Obtener lista de productos
    this.productsService.getProducts().subscribe(res => {
      console.log(res);
      let data = res.result;
      if (res.status === "ok") {
        this.setDataProducts(data);
      }
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('An error occurred:', err.error.message);
      } else {
        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
      }
    });

    //contador y valor total productos adicionales
    this.store.select('carCheckout').subscribe(product => {
      this.aditionalProducts = product;
      this.summary = 0;
      this.count = 0;
      product.forEach(item => {
        this.summary = this.summary + item.totalPrice;
        this.count = this.count + item.quantity;
      });
    });
    //Obtener informacion planes y productos del usuario
    const havePlan = await this.consultingActivePlan();
    if (havePlan) {
      if (this.activePlan.products.length >= 1) {
        this.activePlan.products.forEach(product => {
          switch (product.codeProduct) {
            case 'PD01':
              this.foto36 = product.amountPurchased - product.amountUsed;
              break;
            case 'PD02':
              this.recorrido3d = product.amountPurchased - product.amountUsed;
              break;
            case 'PD03':
              this.ascendidos = product.amountPurchased - product.amountUsed;
              break;
            case 'PD04':
              this.destacados = product.amountPurchased - product.amountUsed;
              break;
            case 'PD05':
              this.precioenlinea = product.amountPurchased - product.amountUsed;
              break;
          }
        });
      }
    }

    let cripto = new Encrypt();
    let dataUser = this.cookieCiencuadras.getCookie('userInfo');
    this.userInformation = cripto.decryptData(dataUser);
  }

  removeAlert(event){
    const alertElement = event.target.closest('.alert');
    alertElement.classList.add('dissmiss');
    setTimeout(() => alertElement.remove(),300);
  }

  async consultingActivePlan() {
    let cripto = new Encrypt();
    console.log('---------- consultingActivePlan() ----------');
    console.log('this.cookieCiencuadras.getCookie(user_id) decryptDataIV: ', cripto.decryptDataIV(this.cookieCiencuadras.getCookie('user_id')));
    let user_id: string = this.cookieCiencuadras.getCookie('user_id') ? this.cookieCiencuadras.getCookie('user_id') : localStorage.getItem('currentUser');
    let id: number = parseInt(cripto.decryptDataIV(user_id).split('|')[0]);
    console.log('id: ', id);

    console.log('---------- consultingActivePlan() ----------');

    // const id: number = parseInt(this.cookieCiencuadras.getCookie('currentUser'));
    return new Promise((resolve) => {
      this.productsService.activePlans(
        id
      ).pipe().subscribe(res => {
        console.log('------------------', res);
        if (res.result.activePlans.length >= 1) {
          console.log(res.result.activePlans);
          this.activePlan = res.result.activePlans[0];
          resolve(true);
        }
        resolve(false);
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
        }
        resolve(false);
      });
    });
  }

  async onClickPayPlan() {

    //TODO:PRUEBAS BASE DE COBRO
    // this.clearShoppingCar();
    // let res = {
    //   "status": "ok",
    //   "messages": null,
    //   "error": null,
    //   "basePaymentDTO": {
    //     "planItem": {
    //       "id": 46,
    //       "name": "Plan L para elige tu plan para inmobiliaria",
    //       "paidValue": 402000.00,
    //       "includedAmount": 1,
    //       "additionalAmount": 0,
    //       "staticImage": "ideal-l",
    //       "shoppingCarId": 150
    //     },
    //     "productItems": {
    //       "7": {
    //         "id": 7,
    //         "name": "Fotos 360°",
    //         "paidValue": 38000,
    //         "includedAmount": 7,
    //         "additionalAmount": 1,
    //         "staticImage": "foto-360",
    //         "shoppingCarId": 151
    //       },
    //       "8": {
    //         "id": 8,
    //         "name": "Recorrido 3D",
    //         "paidValue": 162000,
    //         "includedAmount": null,
    //         "additionalAmount": 1,
    //         "staticImage": "recorrido-3D",
    //         "shoppingCarId": 152
    //       },
    //       "9": {
    //         "id": 9,
    //         "name": "Ascendidos",
    //         "paidValue": 6000,
    //         "includedAmount": 2,
    //         "additionalAmount": 1,
    //         "staticImage": "ascendidos",
    //         "shoppingCarId": 153
    //       },
    //       "10": {
    //         "id": 10,
    //         "name": "Destacados",
    //         "paidValue": 43000,
    //         "includedAmount": 2,
    //         "additionalAmount": 1,
    //         "staticImage": "destacados",
    //         "shoppingCarId": 154
    //       },
    //       "11": {
    //         "id": 11,
    //         "name": "Precio en linea",
    //         "paidValue": 6000,
    //         "includedAmount": 10,
    //         "additionalAmount": 1,
    //         "staticImage": "asesora-precio",
    //         "shoppingCarId": 155
    //       }
    //     }
    //   }
    // }
    // let data = res.basePaymentDTO;

    // this.setDataBasePlan(data);
    // this.setDataBaseProducts(data.productItems);
    // this.openShoppingDialog();

    // return true;

    //Obtener informacion base de cobro
    this.clearShoppingCar();
    this.productsService.getBasePaymentByUserId(this.id).subscribe(res => {
      console.log(JSON.stringify(res));
      console.log(res);

      if (res.status == "ok") {
        let data = res.basePaymentDTO;

        this.setDataBasePlan(data);
        this.setDataBaseProducts(data.productItems);
        this.openShoppingDialog();
      }
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('An error occurred:', err.error.message);
      } else {
        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
      }
    });
  }

  async clearShoppingCar() {
    if (localStorage.getItem('__app_storage__') !== null) {
      console.log("en borrar carrito");
      const objItems = JSON.parse(localStorage.getItem('__app_storage__')!);
      objItems.carPlanCheckout.forEach((plan: { id: any; }) => this.store.dispatch(removePlanFromCar({ id: plan.id })));
      // objItems.carCheckout.forEach((product: { id: any; }) => this.store.dispatch(removeToCar({ id: product.id })));
    }

  }

  setDataBasePlan(data: any) {
    let dataPlan = data.planItem
    let detail: DetailModal = {
      name: dataPlan.name,
      price: dataPlan.paidValue,
      validity: 0,
      validityLabel: '',
      priceLabel: '',
      topDescription: '',
      relevantCharacteristics: [],
      terms: '',
      aditionalInfoHTML: '',
      urlName: '',
      url: '',
      duration: '',
      unitTimeDuration: '',
      duratrionLabel: '',
      image_url: '',
      discount: 0,
      priceDiscount: dataPlan.paidValue,
      type: 'plan'
    }

    let includedProducts = [];
    for (var key in data.productItems) {
      if (data.productItems[key].includedAmount > 0) {
        let product = {
          cantidadXPlan: data.productItems[key].includedAmount,
          id: data.productItems[key].id,
        };
        includedProducts.push(product);
      }
    }

    let plan: Plan = {
      external_product_id: Date.now().toString(),
      carritoId: dataPlan.shoppingCarId,
      token: '',
      id: dataPlan.id,
      name: dataPlan.name,
      summary: [],
      price: dataPlan.paidValue,
      basePrice: dataPlan.paidBase,
      descriptionValuePlan: '',
      stock: 0,
      available_stock: 0,
      image_url: dataPlan.staticImage,
      image_alt: '',
      iva: dataPlan.iva,
      priceIva: dataPlan.ivaPrice,
      idClientType: '',
      discount: 0,
      priceDiscount: dataPlan.paidValue,
      validity: 0,
      colorCard: '',
      termsDescription: '',
      detailModal: detail,
      includedProducts: includedProducts
    };

    this.cookieCiencuadras.setCookie('selectedPlan', JSON.stringify(plan));
    this.store.dispatch(addToCarPlan({ plan }));
  }

  setDataBaseProducts(data: any) {

    for (var key in data) {
      if (data[key].additionalAmount > 0) {
        let detail: DetailModal = {
          name: data[key].name,
          price: data[key].paidValue,
          validity: 0,
          validityLabel: '',
          priceLabel: '',
          topDescription: '',
          relevantCharacteristics: [],
          terms: '',
          aditionalInfoHTML: '',
          urlName: '',
          url: '',
          duration: '',
          unitTimeDuration: '',
          duratrionLabel: '',
          image_url: data[key].imagenEstatica + '-detalle',
          discount: 0,
          priceDiscount: data[key].paidValue,
          type: 'product'
        }
        let product = {
          external_product_id: Date.now().toString(),
          carritoId: data[key].shoppingCarId,
          token: "",
          id: data[key].id,
          name: data[key].name,
          summary: '',
          price: data[key].paidValue,
          basePrice: data[key].paidBase,
          quantityPlan: data[key].additionalAmount,
          prodCategory: 0,
          code: 0,
          createdManual: 0,
          stock: 0,
          available_stock: 0,
          image_url: data[key].staticImage,
          image_alt: '',
          iva: data[key].iva,
          priceIva: data[key].ivaPrice,
          originId: '',
          idClientType: '',
          discount: 0,
          priceDiscount: data[key].paidValue,
          detailModal: detail,
          quantity: data[key].additionalAmount,
          totalPrice: data[key].paidValue
        }

        this.baseAditionalProducts.push(product);

        let id: any = data[key].id;
        let count = 0;
        let alreadyInCar = false;

        if (localStorage.getItem('__app_storage__') !== null) {
          const objItems = JSON.parse(localStorage.getItem('__app_storage__')!);
         
          if (objItems.carCheckout.length > 0) {
            objItems.carCheckout.forEach((item: { id: any; quantity: any; }) => {
              //Si existe el producto en el carrito
              if (item.id === data[key].id) {
                //Si la cantidad en carrito es mayor a la cantidad adicional quiere decir que el usuario
                //Adiciono mas productos, por lo cual restarle a la cantidad en carrito la cantidad adicional 
                //del plan para que no se vuelva a sumar los productos de la base de cobro si el usuario unde de nuevo pagar plan
                alreadyInCar = true;
                if (item.quantity >= data[key].additionalAmount) {
                  count = item.quantity - data[key].additionalAmount;
                  this.store.dispatch(modifyProduct({ id: id, count: count }));
                } else {
                  //si no es mayor la cantidad en carrito entonces la cantidad es igual a la que tiene carrito
                  count = item.quantity;
                }
                //sumar la cantidad en carrito a la adicional del plan
                count += data[key].additionalAmount;
                this.store.dispatch(modifyProduct({ id: id, count: count }));
              }
            });
          }
          // else {
          //   count = data[key].additionalAmount;
          //   //Adicionar el producto si no existe en el carrito
          //   this.store.dispatch(addToCar({ product }));
          // }
        }
        if(!alreadyInCar){
          count = data[key].additionalAmount;
            //Adicionar el producto si no existe en el carrito
            this.store.dispatch(addToCar({ product }));
        }
      }
    }
  }

  setDataProducts(data: any) {
    for (let i = 0; i < data.length; i++) {
      let discountPrice = 0;
      let clientType = this.cookieCiencuadras.getCookie('clientType');

      if (data[i].porcentajeDescuentoNumero > 0 && data[i].porcentajeDescuentoNumero !== null) {
        discountPrice = data[i].precio - (data[i].precio * data[i].porcentajeDescuentoNumero / 100);
      } else {
        discountPrice = data[i].precio;
      }

      let relevantChar: string[] = [];
      if (data[i].caracteristicasRelevantes !== undefined && data[i].caracteristicasRelevantes !== null) {
        relevantChar = data[i].caracteristicasRelevantes.split(";");
      }
      let urlName = '';
      let url = '';
      if (data[i].nombreUrlEnlace !== undefined && data[i].nombreUrlEnlace !== null) {
        let urlData = data[i].nombreUrlEnlace.split(":");
        urlName = urlData[0];
        url = urlData[1];
      }

      let duration = '';
      let unitTimeDuration = '';

      switch (data[i].unidadTiempoNumero) {
        case 1:
          unitTimeDuration = 'Indefinido';
          duration = '';
          break;
        case 2:
          unitTimeDuration = 'Un día';
          duration = '';
          break;
        case 3:
          unitTimeDuration = 'dias';
          duration = data[i].unidadTiempoNumero;
          break;
        case 4:
          unitTimeDuration = 'Mes';
          duration = data[i].unidadTiempoNumero;
          break;
        case 5:
          unitTimeDuration = 'Año';
          duration = data[i].unidadTiempoNumero;
          break;
        case 6:
          unitTimeDuration = 'Meses';
          duration = data[i].unidadTiempoNumero;
          break;
        default:
          break;
      }

      let detail: DetailModal = {
        name: data[i].nombre,
        price: data[i].precio,
        validity: data[i].mesesVigenciaNumero,
        validityLabel: data[i].etiquetaVigenciaServicio,
        priceLabel: data[i].etiquetaPrecioDetalle,
        topDescription: data[i].descripcionSuperiorDetalle,
        relevantCharacteristics: relevantChar,
        terms: data[i].terminosDetalle,
        aditionalInfoHTML: '',
        urlName: urlName,
        url: url,
        duration: duration,
        unitTimeDuration: unitTimeDuration,
        duratrionLabel: data[i].descripcionDuracionProducto,
        image_url: data[i].imagenEstatica + '-detalle',
        discount: data[i].porcentajeDescuentoNumero,
        priceDiscount: discountPrice,
        type: 'product'
      }
      let product: Product = {
        carritoId: data[i].carritoId,
        token: '',
        id: data[i].id,
        name: data[i].nombre,
        summary: data[i].resumen,
        price: data[i].precio,
        basePrice: data[i].precioBase,
        quantityPlan: data[i].cantidadXPlan,
        prodCategory: data[i].categoriaProdNumero,
        code: data[i].codigo,
        createdManual: data[i].creadoManual,
        stock: data[i].stock,
        available_stock: data[i].disponibleStock,
        image_url: data[i].imagenEstatica,
        image_alt: data[i].altImagen,
        iva: data[i].iva,
        priceIva: data[i].ivaPrecio,
        originId: data[i].origenId,
        idClientType: clientType,
        discount: data[i].porcentajeDescuentoNumero,
        priceDiscount: discountPrice,
        detailModal: detail,
      };
      console.log('producto: ', product);

      this.products.push(product);
    }
  }

  openShoppingDialog = (): void => {
   this.dataLayerService.pushTagEventClick({'event':'ga_event','category':'productos','action':'CCW - productos adicionales','label':`Comprar Productos $ ${this.summary.toLocaleString()}`});
    const shoppingConfig = new MatDialogConfig();
    shoppingConfig.panelClass = 'shopping-modal';
    shoppingConfig.backdropClass = 'shopping-backdrop';
    // shoppingConfig.data = true
    this.dialog.open(ShoppingDialogComponent, shoppingConfig);
  }

  actualizarPlan() {
  this.dataLayerService.pushTagEventClick({'event':'ga_event','category':'productos','action':'CCW - plan actual','label':'Actualizar Plan'});
    this.router.navigateByUrl('/');
  }


}
